import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import H2 from '@base/H2/H2';
import Image from '@base/Image';
import useTopology from '@api/hooks/topology/useTopology';
import { Spacings } from '@styles/index';

const StyledPaper = styled(Paper)`
  display: flex;
`;

const GoalImage = styled.div`
  position: relative;
  height: 64px;
  width: 64px;
`;

const StyH2 = styled(H2)`
  margin: 0;
  margin-left: ${Spacings.SPACING_10B};
  align-self: center;
  color: var(--color-text-primary);
`;
const TopBlock = () => {
  const router = useRouter();
  const { goalUID } = router.query;

  const { topology: goalTopology } = useTopology(goalUID, {
    revalidateOnMount: false
  });

  const { icon, name } = goalTopology;

  return (
    <StyledPaper
      gridColumn="span 18"
      padding={`${Spacings.SPACING_10B} ${Spacings.SPACING_12B}`}
    >
      <GoalImage>
        <Image src={icon} alt={name} layout="fill" />
      </GoalImage>

      <StyH2 as="h1">{name}</StyH2>
    </StyledPaper>
  );
};

export default TopBlock;
